<template>
  <ListView
    modelName="StockTakingItem"
    perm="stock.menu_stock_taking_item"
    svg = "icon_side_inventory_list" 
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_stock_taking_item"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="StockTakingItem"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    borderColor="#61AA72"
    backColor="#EAFFEF"            
    :comparer="(a,b)=>a.id == b.id"
    :popup="popup"                            
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="stockTakingItemStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.stockTakingItemNo }}</GridItem>
    <!-- <GridItem :slot="listSlots[29]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow"/></GridItem> -->
    <!-- <GridItem :slot="listSlots[2]" slot-scope="{ item }">{{ item.seqNo }}</GridItem> -->
    <GridItem :slot="listSlots[2]" slot-scope="{ item }">{{ item.bookDate | date }}</GridItem>
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.warehouse.name }}</GridItem>
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.shelfNo == null ? "" : item.shelfNo.shelfNo }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
    <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.commodity.uom }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.stockTakingNo }}</GridItem>
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:''}}</GridItem>  
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.segmentId | segment }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.stockTaking.pic | userGroup }}</GridItem>
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.stockTaking.refNo }}</GridItem>

    <!-- <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.reserveText1 }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.reserveText2 }}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.reserveText3 }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.reserveText4 }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.reserveText5 }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.reserveText6 }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.reserveMemo1 }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.reserveMemo2 }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.reserveMemo3 }}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.reserveDate1 | date }}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }">{{ item.reserveDate2 | date }}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }">{{ item.reserveDate3 | date }}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }">{{ item.reserveList1 | category_41 }}</GridItem>
    <GridItem :slot="listSlots[26]" slot-scope="{ item }">{{ item.reserveList2 | category_42 }}</GridItem>
    <GridItem :slot="listSlots[27]" slot-scope="{ item }">{{ item.reserveList3 | category_43 }}</GridItem> -->

    <GridItem :slot="listSlots[14]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ? item.commodity.reserveText1 : item.reserveText1)}}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ? item.commodity.reserveText2 : item.reserveText2)}}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ? item.commodity.reserveText3 : item.reserveText3)}}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ? item.commodity.reserveText4 : item.reserveText4)}}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ? item.commodity.reserveText5 : item.reserveText5)}}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ? item.commodity.reserveText6 : item.reserveText6)}}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ? item.commodity.reserveMemo1 : item.reserveMemo1)}}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ? item.commodity.reserveMemo2 : item.reserveMemo2)}}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ? item.commodity.reserveMemo3 : item.reserveMemo3)}}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ? item.commodity.reserveDate1 : item.reserveDate1) | date}}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ? item.commodity.reserveDate2 : item.reserveDate2) | date}}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ? item.commodity.reserveDate3 : item.reserveDate3)| date}}</GridItem>
    <GridItem :slot="listSlots[26]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ? item.commodity.reserveList1 : item.reserveList1 ) | category_41}}</GridItem>
    <GridItem :slot="listSlots[27]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ? item.commodity.reserveList2 : item.reserveList2 ) | category_42}}</GridItem>
    <GridItem :slot="listSlots[28]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ? item.commodity.reserveList3 : item.reserveList3 ) | category_43}}</GridItem> 

    <GridItem :slot="listSlots[29]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[30]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[31]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[32]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :add="false" :copy="false" >
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">
        <FilterBox title="棚卸処理番号" :value.sync="params.stockTakingNo" @click="handler" />
        <FilterBox title="棚卸処理明細番号" :value.sync="params.stockTakingItemNo" @click="handler" />        
        <FilterBox title="管理番号" :value.sync="params.refNo" @click="handler" />
        <AtcCounterpart title="倉庫" :value.sync="params.warehouse" :needsWarehouse="true" @changed="handler" />
        <AtcProjectItem title="案件" :value.sync="params.projectItem" @changed="handler"/>           
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />          
        <Calendar title="発生日(From)" :value.sync="params.bookDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="発生日(To)" :value.sync="params.bookDateTo" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />                 
        <ComboBox title="状態" :value.sync="params.state" list="stockTakingItemStatus" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','予備項目','更新履歴']">
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <TextBox title="明細番号" :value="item.stockTakingItemNo" :editor="editor" :enabled="false" tooltip="棚卸処理番号に紐づく明細番号が初回保存時に自動で付与されます。" />
              <!-- <TextBox title="行番号" :value="item.seqNo" :editor="editor" :enabled="false" /> -->
              <Calendar title="発生日" :value="item.bookDate" :editor="editor" :enabled="false" tooltip="【在庫一覧】の棚卸処理子画面で指定された発生日です。" />              
              <AtcCounterpart title="倉庫" :value="item.warehouse" :editor="editor" :needsWarehouse="true" :enabled="false" tooltip="棚卸処理を行う倉庫です。" />
              <TextBox title="棚番号" :value="(item.shelfNo ? item.shelfNo.shelfNo : '')" :editor="editor" :enabled="false" tooltip="倉庫内で在庫を持つ棚番号です。【棚番号マスタ】で登録されている棚番号です。" />
              <AtcCommodity title="商品" :value="item.commodity" :editor="editor" :enabled="false" tooltip="棚卸処理を行う商品です。変更する場合は改めて棚卸処理を行ってください。" />
              <AtcSKU title="SKU" :value="item.sku" :editor="editor" :commodity="item.commodity" :enabled="false" tooltip="棚卸処理を行う商品のSKUです。変更する場合は改めて棚卸処理を行ってください。" />
              <TextBox title="単位" :value="item.commodity.uom" :editor="editor" :enabled="false" tooltip="棚卸処理を行う商品の【計上単位】です。" />
              <NumericBox title="減耗数量" :value.sync="item.quantity" :editor="editor" :required="true" :enabled="item.state == savingFlag" :decimals="item.commodity.quantityScale" min="-99999999.999" max="99999999.999" :nullValue="0" tooltip="棚卸処理を行った結果発生した減耗数量です。減耗数量分在庫数が変化します。" />
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <TextBox title="棚卸処理番号" :value="item.stockTakingNo" :enabled="false" :linkFormat="getStockTakingLinkFormat(item)" tooltip="棚卸処理の初回保存時に自動で付与された番号です。" />              
              <AtcProjectItem title="案件" :value.sync="item.projectItem" :editor="editor"  :enabled="false"/>                   
              <AtcSegment title="部門" :value="item.segment" :editor="editor" :enabled="false" tooltip="棚卸処理を行う部門です。" />
              <AutoComplete title="担当者" :value="item.stockTaking.pic" :editor="editor" list="user" :enabled="false" tooltip="棚卸処理の担当者が表示されています。棚卸処理明細一覧からの変更は出来ません。" />
              <TextBox title="管理番号" :value="item.stockTaking.refNo" :editor="editor" :enabled="false" tooltip="棚卸処理の管理番号が表示されています。棚卸処理明細一覧からの変更は出来ません。" />
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="在庫移動明細情報を最後に編集した日時が表示されています。" />                      
              <!-- <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_stockTakingItem" :required="$api.perms.hasWorkflow('stockTakingItem')" :enabled="$api.perms.hasWorkflow('stockTakingItem') && $api.perms.isEntryStatus(item)" :nullValue="0" /> -->
              <TextBox title="状態" :value="$api.perms.getStateLabel(item,'stockTakingItemStatus')" :enabled="false" tooltip="棚卸情報の現在の状態です。" />                  
            </template>
          </EditPanel>
        </template>
        <!-- 予備項目タブ -->
        <template slot="tab1" slot-scope="{ item,editor }">
          <PnlReserveItems :item="item" :editor="editor" :enabled="false" :commodityAttribute="visibleTypes.ReadOnly" :stockAttribute="visibleTypes.Editable"  :orderMemo="visibleTypes.ReadOnly" :deliveryMemo="visibleTypes.Editable" :commodity="item.commodity" /> 
        </template>        
        <!-- 更新履歴タブ -->
        <template slot="tab2" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class StockTakingItemView extends Vue {
  public items: Common.StockTakingItem[] = new Array(0);
  public params: Common.StockTakingItemQuery = new Common.StockTakingItemQuery();
  public importQuery = new Common.ImportQuery('棚卸処理明細','StockTakingItem');
  public exportQuery = new Common.StockTakingItemExportQuery('棚卸処理明細',this.params);
  public tenantSettings: Common.TenantSettings = null;
  public usedTypes = Common.UsedTypes;
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'stockTakingItemNo', text: '明細番号' },
    { value: 'stockTakingNo', text: '棚卸処理番号' },
    { value: 'bookDate', text: '発生日' },    
    { value: 'commodity', text: '商品' },        
    { value: 'shelfno', text: '棚番号' },           
    { value: 'warehouse', text: '倉庫' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },         
  ];
  @Prop() public stockTakingNo:string;
  @Prop() public stockTakingItemNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor; 

  public inputType:Common.InputTypes = Common.InputTypes.None;
  public savingFlag: Common.StockBalanceJournalStatus = Common.StockBalanceJournalStatus.StockTakingWaiting;
  public visibleTypes = Common.visibleTypes;  

  //一覧項目可変プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public listGridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  public created() {
    this.tenantSettings = this.$api.tenantSettings;

     // 明細の予備項目表示の可変対応


    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('明細番号', 150),
      // new Common.GridItemConfiguration('ワークフロー', 150),      
      // new Common.GridItemConfiguration('行番号', 150),
      new Common.GridItemConfiguration('発生日', 150),
      new Common.GridItemConfiguration('倉庫', 150),
      new Common.GridItemConfiguration('棚番号', 150),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('減耗数量', 150),
      new Common.GridItemConfiguration('棚卸処理番号', 150),      
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      new Common.GridItemConfiguration('管理番号', 150),
    );
    this.listGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));    //商品識別情報+在庫識別情報
    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );
    this.listCaptions =this.listGridConfig.gridCaptions;
    this.listWidths = this.listGridConfig.gridWidths;
    this.listSlots = this.listGridConfig.gridSlots;

    // 検索条件を設定する
    if(this.stockTakingNo){
      this.params.stockTakingNo = this.stockTakingNo;
      this.params.state = null;
    }
    if(this.stockTakingItemNo) {
      this.params.stockTakingItemNo = this.stockTakingItemNo;
      this.params.state = null;
    }
    if(!this.stockTakingNo && !this.stockTakingItemNo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  public async onCreate(obj: Common.StockTakingItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_stockTakingItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 棚卸処理一覧へ遷移する
  public getStockTakingLinkFormat(item : Common.StockTakingItem){
    return '/journal/StockTaking?stockTakingNo={0}';
  }
  
}
</script>